import { observer } from 'mobx-react-lite'
import { useStore } from '~/app/store'
import { ProductsCategoriesFilters } from '~/features/products/categories'
import Spinner from '~/shared/ui/spinner'

export const StoresFilterWidget = observer(() => {
  const { globalStore } = useStore()
  const { stores } = globalStore

  return globalStore.loading ? (
    <div className="my-10 flex items-center justify-center">
      <Spinner />
    </div>
  ) : (
    <ProductsCategoriesFilters data={stores} />
  )
})
